import * as React from "react";
import FeaturedProducts from "../featured-products";
export default class Products extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (this.props.featuredProducts.length > 0 ?
            React.createElement("div", { className: "store-template-b__products" },
                React.createElement("div", { className: "store-template-b__products__wrap" },
                    React.createElement("a", { "data-name": "products" }),
                    React.createElement("h2", null, "Featured Products"),
                    React.createElement(FeaturedProducts, Object.assign({}, this.props)))) : null);
    }
}
;
//# sourceMappingURL=products.js.map